import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import App from './App.vue';
import store from './store';
import router from './router';
import vuetify from './plugins/vuetify';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn:
      'https://fe6ebf255b5d4bd3a8c209402f703c0c@o347992.ingest.sentry.io/5360105',
    integrations: [new VueIntegration({ Vue, attachProps: true })],
  });
}

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
